import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { ModalConfig } from '@shared/components/modal/modal.interface';

@Component({
  selector: 'app-modal-confirm-cancel',
  templateUrl: './modal-confirm-cancel.component.html',
  styleUrls: ['./modal-confirm-cancel.component.scss'],
})
export class ModalConfirmCancelComponent {
  @Output() resetForm = new EventEmitter<boolean>();

  @ViewChild('modalConfirmCancel') cancelDialog: ModalComponent;
  modalConfig: ModalConfig = {
    modalTitle: 'Batal Generate Batch QR',
    closeButtonLabel: 'Batal',
    dismissButtonLabel: 'Lanjutkan',
    onClose: () => this.handleOnClose(),
  };

  openDialog() {
    return this.cancelDialog.open();
  }

  handleOnClose() {
    this.resetForm.emit(true);
    return true;
  }
}
